import { unauthenticatedApi } from "@/utils/api";

export const signUp = async (email: string, turnstileToken: string): Promise<void> => {
  await unauthenticatedApi.post("/auth/signup", { email, turnstile_token: turnstileToken });
};
